<template>
  <header class="header">
    <div class="loader-circle">
      <img src="../assets/images/loader.gif" alt="">
    </div>
    <div class="header__inner wrapper">
      <a href="/" class="header__logo">
<!--				<span class="header__sub-logo">-->
<!--					<img class="" src="../assets/images/sublogo-icon.svg" alt="">-->
<!--				</span>-->
<!--        <img src="../assets/images/logo-icon.svg" alt="">-->
        <img src="/img/logo.0b2f8c7f.svg" alt="">
      </a>
      <nav>
        <ul class="header__nav">
          <li class="header__item">
            <a class="header__nav__link" href="/">
              <span>Выход</span>
              <img class="header__exit" src="../assets/images/icon-exit.svg" alt="">
            </a>
          </li>
          <li class="header__item header__item_mobile">
            <img @click="openFilter" src="../assets/images/filter-icon.svg" alt="">

            <div class="header__item-content header__item-content_height header__item-content_index" :class="{'header__item-content_active': isOpenFilter}">
              <TheFilters v-if="isMobileFilter" @close="openFilter"/>
            </div>
          </li>
          <li class="header__item header__item_mobile" @click="openMenu">
            <template v-if="!isOpenMenu">
              <img class="header__header-icon" src="../assets/images/burger-icon.svg" alt="">
            </template>
            <template v-else>
              <img class="header__header-icon" src="../assets/images/blue-cross-icon.svg" alt="">
            </template>

            <div class="header__item-content header__item-content_padding" :class="{'header__item-content_active': isOpenMenu}">
              <a class="header__nav__link" href="#">
                <span>Выход</span>
                <img class="header__exit" src="../assets/images/icon-exit.svg" alt="">
              </a>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
  import TheFilters from './TheFilters';
  export default {
    name: 'TheHeader',
    data:() => ({
      isOpenFilter: false,
      isOpenMenu: false,
      isMobileFilter: false
    }),
    methods: {
      openFilter() {
        this.isOpenFilter = !this.isOpenFilter;
      },
      openMenu() {
        this.isOpenMenu = !this.isOpenMenu;
      }
    },
    components: {
      TheFilters
    },
    mounted() {
      this.isMobileFilter = window.screen.width < 768;
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!--<style src="vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css"></style>-->
